import CryptoJS from "crypto-js";

// 邀请链接参数加密密钥：通过 .env 的 VUE_APP_INVITE_SECRET 配置，
// 加解密均在同一前端工程内完成，更换密钥后历史链接将失效
const SECRET_KEY: string =
  process.env.VUE_APP_INVITE_SECRET || "logistics-meet-invite-secret";

/**
 * 对象加密为可放入 URL 的参数（JSON -> AES -> Base64 -> encodeURIComponent）
 * 密文为随机盐加密结果，同一内容每次生成的密文都不同，无法直接比对/猜测
 */
export const encryptParam = <T extends Record<string, unknown>>(
  data: T
): string =>
  encodeURIComponent(
    CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString()
  );

/**
 * 解密 URL 参数为对象；密钥不符、参数被篡改或格式非法时返回 null
 * （vue-router 已对 query 做过一次解码，这里再解码一次以兼容手工拼接的场景）
 */
export const decryptParam = <T>(text: unknown): T | null => {
  if (!text || typeof text !== "string") return null;
  try {
    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(text), SECRET_KEY);
    const json = bytes.toString(CryptoJS.enc.Utf8);
    return json ? (JSON.parse(json) as T) : null;
  } catch {
    return null;
  }
};
